// quillInit-suggest.js
import Quill from "quill";
const Parchment = Quill.import("parchment");

class SuggestInsert extends Parchment.Attributor.Attribute {}
class SuggestDelete extends Parchment.Attributor.Attribute {}

const suggestInsert = new SuggestInsert("suggest-insert", "data-suggest-insert", { scope: Parchment.Scope.INLINE });
const suggestDelete = new SuggestDelete("suggest-delete", "data-suggest-delete", { scope: Parchment.Scope.INLINE });

Quill.register(suggestInsert, true);
Quill.register(suggestDelete, true);

export default Quill;
